import React from 'react';
const IconCommentAddFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 22H12.11L15.47 18H22V2H2V18H10V22ZM8 11V9H11V6H13V9H16V11H13V14H11V11H8Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconCommentAddFill;